export default __webpack_public_path__ + "images/S2.27b6cba.png";